import React, { Fragment, useMemo } from 'react';
import AppTable from '../../../constants/AppTable';
import { LoadingSpinner } from '../../../constants/AppLoading';

interface Province {
    province_id: number;
    province_name: string;
    province_name_nep: string;

}
interface AuthorTableListViewProps {
    data: {
        data: Province[];
    } | null;
    loading: boolean;
    error: string | null;
    setOnID: (id: number | null) => void;
}

const ProvinceListView: React.FC<AuthorTableListViewProps> = ({ data, loading, error, setOnID }) => {
    const columns = [
        { header: 'SN', accessor: 'province_id', sortable: false, width: 2 },
        { header: 'Province Name', accessor: 'province_name', sortable: true },
        { header: 'Province Name(Nepali)', accessor: 'province_name_nep', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },  // Set the accessor to 'actions' and set `action` to `true`
    ]

    const modifiedData = useMemo(() => {
        if (!data) return [];
        return data.data.map((item: Province) => ({
            province_id: item.province_id,
            province_name: `${item.province_name}`,
            province_name_nep: item.province_name_nep,
        }));
    }, [data]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    const handleEdit = (row: any) => {
        setOnID(row.province_id)
    };

    return (
        <Fragment>
                <AppTable
                    columns={columns}
                    data={modifiedData}
                    onEdit={handleEdit}
                />
        </Fragment>
    );
};

export default ProvinceListView;
